import * as React from 'react'
import { observer } from 'mobx-react'
import { useBrandingSettings } from 'hooks/branding'
import ErrorBlock from 'components/ErrorBlock'
import CloseJobViewModel from './CloseJobViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import Button from 'components/Button'

interface Props {
  modal: CloseJobViewModel | null
}

export default observer(function CloseJobDialog({ modal }: Props) {
  const { corporateMode } = useBrandingSettings()

  if (!modal) {
    return null
  }

  return (
    <ModalSheet showing={modal.showing} onRequestClose={modal.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_job-rating.svg')}
              alt="Illustration of a finger tapping a star rating on a phone"
            />
          )}
          <CloseJobDialogHeaderContent />
        </ModalSheetContentBlock>
      </ModalSheetContent>
      {modal.submit.rejected && (
        <ErrorBlock
          tackOn="bottom"
          error={modal.submit.error}
          onCloseClick={() => modal.submit.reset()}
        />
      )}
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={modal.close} disabled={modal.submit.pending}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={modal.submit}
            disabled={modal.submit.pending}
            loading={modal.submit.pending}
            data-test="complete-job-button"
          >
            Complete
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

function CloseJobDialogHeaderContent() {
  return (
    <>
      <ModalSheetContentTitle>Complete Job</ModalSheetContentTitle>
      <ModalSheetContentDescription compact>
        By marking this job as completed, communication with the client will
        cease.
      </ModalSheetContentDescription>
    </>
  )
}
